import api from "../lib/api.ts";

// Fetch packages assigned to a specific seller user using existing user endpoint
export const getSellerAssignedPackages = async (userId: number) => {
  try {
    const response = await api.get(`/users/user/${userId}`);
    const userData = response.data;
    
    // Extract package information from the user response
    if (userData?.seller?.sellerPackageHistory) {
      const packageHistory = userData.seller.sellerPackageHistory;
      
      // If you need more package details, you can fetch them using the sellerPackageId
      if (packageHistory.sellerPackageId) {
        try {
          const packageResponse = await api.get(`/sellerPackages/${packageHistory.sellerPackageId}`);
          return {
            ...packageResponse.data,
            isActive: packageHistory.isActive,
            assignedDate: userData.createdAt,
            // Include additional fields from the detailed package response
            packageId: packageHistory.sellerPackageId,
            historyId: packageHistory.id,
            // Add any other fields you need
          };
        } catch (packageError) {
          console.error("Error fetching package details:", packageError);
          // Return basic package info if detailed fetch fails
          return {
            id: packageHistory.id,
            sellerPackageId: packageHistory.sellerPackageId,
            isActive: packageHistory.isActive,
            assignedDate: userData.createdAt,
            // You can add default values here
            name: "Assigned Package",
            status: packageHistory.isActive ? "active" : "inactive"
          };
        }
      }
    }
    
    return null; // No package assigned
  } catch (error) {
    console.error("Error fetching seller assigned packages:", error);
    throw error;
  }
};

// Fetch packages assigned to a specific buyer user
export const getBuyerAssignedPackages = async (buyerId: number) => {
  try {
    const response = await api.get(`/users/user/${buyerId}`);
    const userData = response.data;
    
    // Extract package information from the user response
    if (userData?.buyer?.buyerPackageHistory) {
      const packageHistory = userData.buyer.buyerPackageHistory;
      
      // Similar logic for buyer packages
      if (packageHistory.buyerPackageId) {
        try {
          const packageResponse = await api.get(`/buyerpackages/${packageHistory.buyerPackageId}`);
          return {
            ...packageResponse.data,
            isActive: packageHistory.isActive,
            assignedDate: userData.createdAt,
          };
        } catch (packageError) {
          console.error("Error fetching buyer package details:", packageError);
          return {
            id: packageHistory.id,
            buyerPackageId: packageHistory.buyerPackageId,
            isActive: packageHistory.isActive,
            assignedDate: userData.createdAt,
            name: "Assigned Package",
            status: packageHistory.isActive ? "active" : "inactive"
          };
        }
      }
    }
    
    return null; // No package assigned
  } catch (error) {
    console.error("Error fetching buyer assigned packages:", error);
    throw error;
  }
};

// Fetch all available seller packages (general packages)
export const getAllSellerPackages = async () => {
  try {
    const response = await api.get("/sellerpackages");
    return response.data;
  } catch (error) {
    console.error("Error fetching all seller packages:", error);
    throw error;
  }
};

// Fetch all available buyer packages (general packages)
export const getAllBuyerPackages = async () => {
  try {
        const response = await api.get("/buyerpackages");
        return response.data;
      } catch (error) {
        console.error("Error fetching all buyer packages:", error);
        throw error;
      }
    };

// Fetch package details by ID
export const getPackageById = async (packageId: number) => {
  try {
    const response = await api.get(`/packages/${packageId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching package details:", error);
    throw error;
  }
};

// Fetch buyer package histories with pagination
export const getBuyerPackageHistories = async (userId: number, page: number = 1, limit: number = 50) => {
  try {
    const response = await api.get(`/buyerpackagehistories/paginated`, {
      params: {
        page,
        limit:1,
        orderBy: 'id',
        order: 'DESC',
        search: '',
        slug: '',
        userId
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching buyer package histories:", error);
    throw error;
  }
};

// Fetch user profile with package information
export const getUserWithPackages = async (userId: number) => {
  try {
    const response = await api.get(`/users/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user with packages:", error);
    throw error;
  }
};
